<style scoped lang="scss" type="text/scss">
    .introduce-container {
        width: 100%;

        .plain-block {
            min-height: 9rem;
        }
    }
</style>

<template>
    <div class="introduce-container">
        <placeholder v-if="data === null">
            未填写参赛介绍
        </placeholder>
        <plain-block class="plain-block" v-else>
            {{ data }}
        </plain-block>
    </div>
</template>

<script>
    import Placeholder from '@/components/placeholder/index';
    import PlainBlock from '@/components/plain-block/index';

    export default {
        name: '',
        props: {
            data: {
                type: String,
                default: () => null
            }
        },
        components: {
            Placeholder,
            PlainBlock
        },
        data () {
            return {};
        }
    };
</script>
